import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { LEGISLATION_FOLDERS } from 'constants/controllers'
import Main from 'redux/containers/pages/legislationfolders/Main'
import LegislationFoldersHeader from './Header'

export default new Controller({
  name: LEGISLATION_FOLDERS,
  route: 'legislation',
  controller (Router, { url, scrollMain, pageView, pageData, params: { aol, path = null }, previousPageId, query }, render) {
    const pageId = getUrl(LEGISLATION_FOLDERS)
    render(
      { Main, Header: LegislationFoldersHeader },
      { act: path, scrollMain, searchType: 'legislation' },
      {
        pageId,
        searchType: 'legislation',
        className: 'legislation'
      }
    )

    return pageId
  }
})
